module.exports = __webpack_public_path__ + "static/media/build.55b1cca5.png";